import styled from 'styled-components'

const MyDiv = styled.div`
  .site-layout .site-layout-background {
    background: transparent;
    padding: 0px!important;
  }
`
export default MyDiv
